module.exports = __webpack_public_path__ + "static/media/Club.eba5eb6e.svg";